export class EncryptionTypeCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "encryptionTypes",
            "baseName": "encryptionTypes",
            "type": "Array<EncryptionType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EncryptionTypeCondition.attributeTypeMap;
    }
    constructor() {
    }
}
